/**
 * Returns a display string for image.imageNumber, disambiguated with the sighting year
 * when the number is known to have duplicates anywhere in the database.
 *
 * Cameras roll over their frame numbers at 9999, so cross-season collisions are
 * expected. The backend flags any image whose number is non-unique
 * (image.imageNumberHasDuplicates) so the year suffix appears consistently
 * regardless of the current view.
 */
export function disambiguatedImageNumber(image) {
  const num = image && image.imageNumber;
  if (!num) return "";
  if (image.imageNumberHasDuplicates && image.sightingYear) {
    return `${num} (${image.sightingYear})`;
  }
  return num;
}

/**
 * Display label for an image: name if set, else disambiguated imageNumber, else imageUuid.
 */
export function imageDisplayLabel(image) {
  if (!image) return "";
  if (image.name) return image.name;
  if (image.imageNumber) return disambiguatedImageNumber(image);
  return image.imageUuid || "";
}

export default { disambiguatedImageNumber, imageDisplayLabel };
